/* Source: /home/ubuntu/libredraw/main.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import "./styles/global.css";
import { App as ClientApp } from "./frontend/App.js";
function App() {
  return __jacJsx(ClientApp, {}, []);
}
const app = App;
/*jac:refresh-boundary*/;
export {app};
//# sourceMappingURL=main.js.map
